// utils/date.ts
export function isBirthdayTodayLocal(d) {
  if (!d) return false;

  // yyyy-MM-dd hoặc yyyy-MM-ddTHH:mm...
  const iso = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    const month = Number(iso[2]) - 1;
    const day   = Number(iso[3]);
    const now   = new Date();
    return now.getMonth() === month && now.getDate() === day;
  }

  // dd/MM/yyyy
  const vn = String(d).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (vn) {
    const month = Number(vn[2]) - 1;
    const day   = Number(vn[1]);
    const now   = new Date();
    return now.getMonth() === month && now.getDate() === day;
  }

  // fallback (ít dùng)
  const dt = new Date(d);
  if (isNaN(dt)) return false;
  const now = new Date();
  return now.getMonth() === dt.getMonth() && now.getDate() === dt.getDate();
}
